import React from 'react';
import {
  accountSearchColumns,
  giaoDichSearchColumns,
  locationSearchColumns,
  loSearchColumns,
  QUERY_KEYS
} from '@/constants';
import { RadixHoverDropdown, FormField, SearchField } from '@/components/custom/erp';
import { SearchDialogActions, SearchDialogState } from '../../hooks';
import { Lo, TaiKhoan, ViTri } from '@/types/schemas';
import { Label } from '@/components/ui/label';

interface OtherTabProps {
  searchState: {
    state: SearchDialogState;
    actions: SearchDialogActions;
  };
}

const OtherTab: React.FC<OtherTabProps> = ({ searchState: { state, actions } }) => {
  return (
    <div className='h-80 w-[800px] min-w-[800px] space-y-4 p-4'>
      <div className='flex flex-col space-y-2'>
        {/* Mẫu lọc báo cáo */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mẫu lọc báo cáo:</Label>
          <div className='flex items-center gap-1'>
            <FormField
              name='report_filtering'
              type='select'
              options={[{ value: '0', label: 'Người dùng tự lọc' }]}
              className='w-96'
            />

            <div className='flex-shrink-0'>
              {/* Fixed size container */}
              <RadixHoverDropdown
                iconNumber={624}
                items={[
                  {
                    value: 'save_new',
                    label: 'Lưu mẫu mới',
                    icon: 7,
                    onClick: () => console.log('Save new filter template')
                  },
                  {
                    value: 'save_overwrite',
                    label: 'Lưu đè vào mẫu đang chọn',
                    icon: 75,
                    onClick: () => console.log('Overwrite current filter template')
                  },
                  {
                    value: 'delete',
                    label: 'Xóa mẫu đang chọn',
                    icon: 8,
                    onClick: () => console.log('Delete current filter template')
                  }
                ]}
              />
            </div>
          </div>
        </div>

        {/* Mẫu phân tích dữ liệu */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mẫu phân tích DL:</Label>
          <div className='flex items-center gap-1'>
            <FormField
              name='data_analysis_struct'
              type='select'
              options={[{ value: '0', label: 'Không phân tích' }]}
              className='w-96'
            />

            <div className='flex-shrink-0'>
              {/* Fixed size container */}
              <RadixHoverDropdown
                iconNumber={790}
                items={[
                  {
                    value: 'save_new',
                    label: 'Lưu mẫu mới',
                    icon: 7,
                    onClick: () => console.log('Save new analysis template')
                  },
                  {
                    value: 'save_overwrite',
                    label: 'Sửa mẫu đang chọn',
                    icon: 9,
                    onClick: () => console.log('Overwrite current filter template')
                  },
                  {
                    value: 'delete',
                    label: 'Xóa mẫu đang chọn',
                    icon: 8,
                    onClick: () => console.log('Delete current filter template')
                  }
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherTab;
